import {Card} from 'platform/components';
import {Box, Heading, Text, VStack} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {useEffect, useState} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {useGetBatchQuery} from '../../../store/importApi';

const BATCH_POLLING_INTERVAL_MS = 10_000;

interface ImportPricingViewProps extends TestIdProps {
  batchId: string;
}

export function ImportPricingView(props: ImportPricingViewProps) {
  const [pollingInterval, setPollingInterval] = useState(BATCH_POLLING_INTERVAL_MS);

  const {data: batch, isError: isBatchError} = useGetBatchQuery(
    {batchId: props.batchId},
    {pollingInterval, skipPollingIfUnfocused: true}
  );

  useEffect(() => {
    if (isBatchError || batch?.status === 'done') {
      setPollingInterval(0);
    }
  }, [batch?.status, isBatchError]);

  const statusMessage = match<[boolean, string | undefined], string>([isBatchError, batch?.status])
    .with([true, Pattern.any], () => i18n.t('page.import.pricing.error'))
    .with([false, 'pricing'], () => i18n.t('page.import.pricing.inProgress'))
    .with([false, 'done'], () => i18n.t('page.import.pricing.done'))
    .otherwise(() => i18n.t('page.import.pricing.inProgress'));

  return (
    <Box width="100%" data-testid={suffixTestId('wrapper', props)}>
      <Card data-testid={suffixTestId('card', props)}>
        <Box padding={6}>
          <VStack spacing={4}>
            <Heading size={1}>{i18n.t('page.import.labels.stepVehiclePricing')}</Heading>
            <Text size="base" color="secondary">
              {statusMessage}
            </Text>
          </VStack>
        </Box>
      </Card>
    </Box>
  );
}
